// document
//   .querySelector(".product-buy-buttons--checkout")
//   .addEventListener("click", function (event) {
//     event.preventDefault();

//     const form = document.querySelector("form");
//     if (!form) return;

//     const formData = new FormData(form);

//     const selectedOption = form.querySelector("option[selected]");
//     const quantityInput = form.querySelector("[name=quantity]");
//     const quantity = quantityInput ? quantityInput.value : 1;

//     const productId = selectedOption ? selectedOption.dataset.id : null;

//     if (!productId) return;

//     const buttonContainer = document.querySelector(
//       ".product-buy-buttons--checkout-container"
//     );
//     buttonContainer.setAttribute("data-loading", "true");

//     const requestOptions = {
//       method: "POST",
//       headers: { "Content-Type": "application/x-www-form-urlencoded" },
//       body: new URLSearchParams(formData).toString(),
//     };

//     fetch("/cart/add.js", requestOptions)
//       .then((response) => {
//         if (!response.ok) throw new Error("Failed to add to cart");
//         return response.json();
//       })
//       .then((data) => {
//         setTimeout(() => {
//           buttonContainer.setAttribute("data-loading", "false");
//           window.location.href = "/checkout";
//         }, 1000);
//       })
//       .catch((error) => {
//         console.error("Error adding to cart:", error);
//         buttonContainer.setAttribute("data-loading", "false");
//       });
//   });

class ProductBuyButtons extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.button_container = this.querySelector(
      ".product-buy-buttons--primary"
    )),
      (this.button_text = this.querySelector(".product-buy-buttons--cta-text")),
      (this.select_input = this.querySelector(".product-buy-buttons--select")),
      (this.smart_button = this.querySelector(".product-buy-buttons--smart")),
      (this.primary_button = this.querySelector(".product-buy-buttons--cta")),
      this.addToCartListener(),
      this.updateViewListener();
  }
  addToCartListener() {
    this.closest("form").on("submit", async (t) => {
      var e = this.querySelector("option[selected]")["dataset"],
        r = t.target.querySelector("[name=quantity]"),
        a = theme.utils.getQuantity(this.dataset.id, e, r.value);
      if (
        (("drawer" !== theme.settings.cart_type && !1 !== a) ||
          (t.preventDefault(), t.stopPropagation()),
        a &&
          (this.button_container.setAttribute("data-loading", !0),
          "drawer" === theme.settings.cart_type))
      ) {
        var i = new FormData(t.target),
          s = {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams(i).toString(),
          };
        try {
          await theme.cart.addItem(s, e.id),
            this.button_container.setAttribute("data-loading", !1),
            theme.drawer.open("right", "cart-drawer", this.primary_button);

            upsellplusapp.init_drawer_offer();
          
        } catch (t) {
          throw (
            (this.button_container.setAttribute("data-loading", !1),
            new Error(t))
          );
        }
      }
    });
  }
  updateViewListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged`,
      ({ detail: { variant: t } }) => {
        var e = this.select_input.querySelector("option[selected]");
        e && e.removeAttribute("selected"),
          t && t.available
            ? (this.selectVariant(t.id), this.updateView(!0, !0))
            : t && !t.available
            ? (this.selectVariant(t.id), this.updateView(!1, !0))
            : this.updateView(!1, !1);
      }
    );
  }
  selectVariant(t) {
    var e = this.select_input.querySelector(`option[value='${t}']`);
    e && e.setAttribute("selected", !0);
  }
  // updateView(t, e) {
  //   t
  //     ? (this.primary_button.removeAttribute("disabled"),
  //       (this.button_text.innerText = theme.translations.add_to_cart),
  //       this.smart_button && this.smart_button.setAttribute("aria-hidden", !1))
  //     : (this.primary_button.setAttribute("disabled", !0),
  //       this.smart_button && this.smart_button.setAttribute("aria-hidden", !0),
  //       (this.button_text.innerText = e
  //         ? theme.translations.out_of_stock
  //         : theme.translations.unavailable));
  // }
}
const productBuyButtonsEl = customElements.get("product-buy-buttons-root");
productBuyButtonsEl ||
  customElements.define("product-buy-buttons-root", ProductBuyButtons);
